<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                                <form>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-3">
                                            <label for="c_training_trade_id">Training Trade</label>
                                            <select v-model="search_data.c_training_trade_id"
                                                    id="c_training_trade_id" class="form-control form-control-sm" name="c_training_trade_id">
                                                <option :value="''" selected>Select Training Trade</option>
                                                <option v-for="(trade, index) in trades" :key="index" v-bind:value="trade.id">
                                                    {{ trade.id }} : {{ trade.desc }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-3">
                                            <label for="batch_no">Batch No</label>
                                            <select class="form-control form-control-sm" v-model="search_data.batch_no" id="batch_no" name="batch_no">
                                                <option :value="''" selected>Select Batch no.</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-3">
                                            <label for="c_training_trade_id">Training Venue</label>
                                            <select v-model="search_data.c_training_venue_id"
                                                    id="c_training_venue_id" class="form-control form-control-sm" name="c_training_venue_id">
                                                <option :value="''" selected>Select Training Venue</option>
                                                <option v-for="(venue, index) in venues" :key="index" v-bind:value="venue.id">
                                                    {{ venue.id }} : {{ venue.desc }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-3">
                                            <label for="batch_status">Batch Status</label>
                                            <select class="form-control form-control-sm" v-model="search_data.batch_status" id="batch_status" name="batch_status">
                                                <option :value="''" selected>Select Batch Status</option>
                                                <option value="Completed">Completed</option>
                                                <option value="Ongoing">Ongoing</option>
                                                <option value="Upcoming">Upcoming</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-row mt-1">
                                      <div class="col-md-6 col-sm-6 col-lg-3">
                                        <label for="c_training_pkg_id">Package</label>
                                        <select class="form-control form-control-sm" v-model="search_data.c_training_pkg_id" id="c_training_pkg_id" name="c_training_pkg_id">
                                          <option :value="''" selected>Select Package</option>
                                          <option v-for="(c_package, index) in packages" :key="index" v-bind:value="c_package.id">
                                            {{ c_package.id }} : {{ c_package.desc }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                     <button class="btn btn-success mt-2" @click.prevent="search">Search</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-sm-12">
                                <div v-if="flag">
                                    <span class="badge badge-success">Total Search Data Found: {{ batches.total }}</span>
                                    <download-excel
                                            class = "btn btn-light float-right"
                                            :fetch = "fetchData"
                                            :fields = "batch_fields"
                                            :meta="json_meta"
                                            worksheet = "batch"
                                            name = "batch.xls">
                                        Download Excel
                                    </download-excel>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0" style="overflow-x: auto">
                            <table class="table table-centered table-striped">
                                <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Training Trade | Batch No</th>
                                    <th>Total Trainee</th>
                                    <th>Male|Female</th>
                                    <th>Duration</th>
                                    <th>Venue</th>
                                    <th>Package</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(batch, index) in batches.data" :key="index">
                                    <td>{{ batches.from + index }}</td>
                                    <td>
                                        <router-link :to="{
                                            name: 'tradeBatchesView',
                                            params: { trade_id:  batch.trade.id }}" tag="a" target="_blank">
                                            {{ batch.trade.desc }}
                                        </router-link>
                                        | {{ batch.batch_no }}
                                    </td>
                                    <td>{{ batch.trainees ? batch.trainees.length : 0 }}</td>
                                    <td>{{ batch.trainees ? countMale(batch.trainees) : 0 }} | {{ batch.trainees ? countFemale(batch.trainees) : 0 }}</td>
                                    <td>{{ batch.duration.desc }}</td>
                                    <td>{{ batch.venue.desc }}</td>
                                    <td>{{ batch.package.desc }}</td>
                                    <td>{{ batch.start_date }}</td>
                                    <td>{{ batch.end_date }}</td>
                                    <td>{{ batchStatus(batch.start_date, batch.end_date) }}</td>
                                    <td>
                                        <span v-if="userPermission.includes('batch-edit')">
                                             <router-link v-if="current_date < batch.end_date"
                                                          target="_blank" :to="{ name: 'batchEdit', params: { batch_id: batch.id } }"
                                                          tag="a" class="action-icon" title="Update batch">
                                                <i class="mdi mdi-square-edit-outline editButton"></i>
                                            </router-link>
                                        </span>
                                        <span v-if="userPermission.includes('batch-delete')">
                                            <a href="javascript:void(0);" v-if="current_date < batch.start_date"
                                               class="action-icon" title="Delete batch" @click="onDelete(batch.id, index)">
                                                <i class="mdi mdi-delete deleteButton"></i>
                                            </a>
                                        </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <h5 v-if="batches.total === 0" class="text-center text-secondary">
                                No Data Found
                            </h5>
                            <div class="float-right">
                                <pagination :data="batches" :limit="2" @pagination-change-page="getResults"></pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import http from "@state/http";
    import moment from "moment";

    export default {
        page: {
            title: 'Batch',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: 'Search Batch',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Batch',
                        href: '/batch/list',
                    },
                    {
                        text: 'List',
                        active: true,
                    },
                ],
                batches: {},
                trades: [],
                venues: [],
                packages: [],
                search_data: {
                    c_training_trade_id: '',
                    batch_no: '',
                    c_training_venue_id: '',
                    batch_status: '',
                     c_training_pkg_id: '',
                },
                current_date: "",
                flag: false,
                batch_fields: {
                    'Trade and Batch' : {
                        callback: (value) => {
                            return `${value.trade ? value.trade.desc : ""} - Batch No.: ${value.batch_no}`;
                        }
                    },
                    'Duration': 'duration.desc',
                    'Package': 'package.desc',
                    'Total Trainees' : {
                        callback: (value) => {
                            return `${value.trainees ? value.trainees.length : 0}`;
                        }
                    },
                    'Start Date': 'start_date',
                    'End Date': 'duration.desc',
                    'Trainee Conveyances': 'trainee_conveyances',
                    'Tax %': 'vat_tax',
                    'Male' : {
                        callback: (value) => {
                            let count = 0;
                            value.trainees.filter(p => {
                                if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 1) {
                                    count += 1;
                                } else if (p.c_rep_gender_id === null && p.c_gender_id === 1) {
                                    count += 1;
                                }
                            });
                            return `${value.trainees ? count : 0}`;
                        }
                    },
                    'Female' : {
                        callback: (value) => {
                            let count = 0;
                            value.trainees.filter(p => {
                                if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 2) {
                                    count += 1;
                                } else if (p.c_rep_gender_id === null && p.c_gender_id === 2) {
                                    count += 1;
                                }
                            });
                            return `${value.trainees ? count : 0}`;
                        }
                    },
                    'Manage By': 'manage_by.desc',
                    'Batch Status' : {
                        callback: (value) => {
                            if (value.end_date < this.current_date){
                                return 'Completed';
                            }else if ((value.end_date >= this.current_date) && (value.start_date <= this.current_date)){
                                return 'Ongoing';
                            }else if (value.start_date > this.current_date){
                                return 'Upcoming';
                            }

                        }
                    },
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            }
        },

        mounted() {
            this.getTrainingTrade();
            this.getTrainingVenue();
            this.checkCurrentDate();
        },
        methods: {
            getTrainingTrade() {
                http.get("api/getTrainingTrade/").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.trades = data.trades;
                    }
                });
            },
            getTrainingVenue() {
                http.get("api/getTrainingVenue/").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.venues = data.venues;
                        this.packages = data.packages;
                    }
                });
            },
            onDelete(id, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/batches/" + id).then(response => {
                        if (response.data.permissionError){
                            this.$bvToast.toast(response.data.permissionError, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }else{
                            this.batches.splice(index, 1);
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                        }
                    });
                }
            },
            search() {
                http.post("api/batch/search", this.search_data).then(response => {
                    if (!response.error) {
                        this.flag = true;
                        this.batches = response.data.batches;
                    }
                });
            },
            checkCurrentDate() {
                this.current_date = moment().format("YYYY-MM-DD");
            },
            countMale(trainees) {
                let count = 0;
                trainees.filter(p => {
                    if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 1) {
                        count += 1;
                    } else if (p.c_rep_gender_id === null && p.c_gender_id == 1) {
                        count += 1;
                    }
                });
                return count;
            },
            countFemale(trainees) {
                let count = 0;
                trainees.filter(p => {
                    if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 2) {
                        count += 1;
                    } else if (p.c_rep_gender_id === null && p.c_gender_id == 2) {
                        count += 1;
                    }
                });
                return count;
            },
            getResults(page = 1) {
                http.post('api/batch/search?page=' + page, this.search_data)
                    .then(response => {
                        this.batches = response.data.batches;
                    });
            },
            batchStatus(start_date, end_date) {
                if (end_date < this.current_date){
                    return 'Completed';
                }else if ((end_date >= this.current_date) && (start_date <= this.current_date)){
                    return 'Ongoing';
                }else if (start_date > this.current_date){
                    return 'Upcoming';
                }
            },
            async fetchData(){
                const response = await http.post("api/batch/report/download_batch", this.search_data);
                return response.data.batches;
            },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    }
</script>

